import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { TodayNow } from "@/components/TodayNow.jsx";
import { phoneReady } from "@/components/HuntMorning.jsx";
import { nextNordQuestStep } from "@/components/NordQuestCenter.jsx";
import { planLine } from "@/components/DayTeams.jsx";
import { CONVOYS, FREEZER, MEET_POINT, TERRAIN_COUNT } from "@/content/huntBoard.js";
import { HUNT_SUPPERS } from "@/content/huntMeals.js";
import { inHuntStay, supperIndexForDate } from "@/lib/huntDates.js";
import { torontoIso } from "@/lib/nowPlan.js";

export function HunterCockpit({ now, onOpen, hunters, tasks, hunterLabel, t, planDay }) {
  const [phones, setPhones] = useState([]);
  const [mineId, setMineId] = useState("");
  const [group, setGroup] = useState(null);
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    api("/api/nordquest").then((body) => {
      setPhones(body.hunters || []);
      setMineId(body.mine || "");
    }).catch(() => setPhones([]));
    api("/api/nordquest/group").then((body) => {
      if (body && Array.isArray(body.hunters)) setGroup(body);
    }).catch(() => setGroup(null));
    if (planDay) {
      api(`/api/day-plan?day=${planDay}`).then((body) => setTeams(body?.teams || [])).catch(() => setTeams([]));
    }
  }, [planDay]);
  const ready = phones.filter(phoneReady).length;
  const sepaqReady = phones.filter((row) => row?.sepaq_downloaded).length;
  const latest = group?.latest;
  const minePhone = phones.find((row) => row.member_id === mineId) || phones[0];
  const openNq = (section) => {
    window.sessionStorage.setItem("orignal2026.nq.section", section || "");
    onOpen("nordquest");
  };
  const iso = torontoIso(now);
  const supperIndex = supperIndexForDate(iso);
  const supper = supperIndex >= 0 ? HUNT_SUPPERS[supperIndex] : HUNT_SUPPERS[0];
  const supperWhen = supperIndex >= 0 ? "Souper ce soir" : "Premier souper, 2 octobre";
  return (
    <div className="og-hunt38" data-testid="cycle-board">
      <header className="og-hunt38__card og-hunt38__today" data-testid="today-hero">
        <TodayNow now={now} onOpen={onOpen} />
      </header>

      <article className="og-hunt38__card og-hunt38__ready is-current" data-testid="next-trip">
        <h2>Sommes-nous prêts ?</h2>
        <p data-testid="current-phase">{t.phaseNow} · {t.prepHuntTitle}</p>
        <ul className="og-ready-strip" data-testid="readiness">
          <li><span>Permis</span><strong>à vérifier</strong></li>
          <li data-testid="sepaq-available"><span>Inscription Sépaq</span><strong>courriel de Chantal</strong></li>
          <li><span>NordQuest</span><strong>{ready} / 6</strong></li>
          <li><span>Matériel personnel</span><strong>essentiels</strong></li>
          <li><span>Matériel commun</span><strong>partiel</strong></li>
          <li><span>Véhicules</span><strong>2 convois connus</strong></li>
          <li><span>Repas</span><strong>soupers assignés</strong></li>
        </ul>
        <div className="og-now__actions">
          <button type="button" className="og-btn" data-testid="hunt-tile-org" onClick={() => onOpen("org")}>Voir la préparation</button>
          <button type="button" className="og-btn" data-testid="tile-mine" onClick={() => onOpen("mine")}>Mes tâches</button>
          <button type="button" className="og-btn" data-testid="tile-gang" onClick={() => onOpen("gang")}>La gang</button>
        </div>
      </article>

      <article className="og-hunt38__card og-hunt38__nq" data-testid="nordquest-block">
        <h2>NordQuest</h2>
        <p data-testid="nordquest-sepaq">Carte Sépaq : {sepaqReady} / 6 prêts</p>
        <p data-testid="nordquest-ready">Carte du groupe V{latest?.code || "1"} · {latest?.point_count || 9} points au total</p>
        {group?.mine_offer === "current" && latest && latest.code !== "1" ? (
          <p data-testid="map-morning">Carte à jour ✓. Version confirmée : V{latest.code}. Points attendus : {group.mine_expected || latest.point_count}.</p>
        ) : null}
        {group?.mine_offer === "delta" ? (
          <>
            <p data-testid="map-morning">Mise à jour disponible</p>
            <button type="button" className="og-btn og-btn--primary" data-testid="install-latest" onClick={() => onOpen("group-map")}>{group.mine_delta_count === 1 ? "Ajouter le nouveau point" : `Ajouter les ${group.mine_delta_count || 0} nouveaux points`}</button>
          </>
        ) : null}
        {group?.mine_offer === "repair" ? (
          <>
            <p data-testid="map-morning">Réparer ma carte</p>
            <p>Réinstaller une copie complète et propre de la dernière carte du groupe.</p>
            <button type="button" className="og-btn og-btn--primary" data-testid="install-latest" onClick={() => onOpen("group-map")}>Réparer ma carte</button>
          </>
        ) : null}
        {group?.mine_offer === "complete" && latest && latest.code !== "1" ? (
          <>
            <p data-testid="map-morning">Installer la carte complète actuelle</p>
            <button type="button" className="og-btn og-btn--primary" data-testid="install-latest" onClick={() => onOpen("group-map")}>Installer la carte complète V{latest.code}</button>
          </>
        ) : null}
        <p data-testid="nordquest-update">Prêt terrain : {ready} / 6</p>
        <p>Ta prochaine étape : {nextNordQuestStep(minePhone)}</p>
        <button type="button" className="og-btn og-btn--primary" data-testid="tile-nordquest" onClick={() => openNq("")}>Continuer ma préparation</button>
        <p className="og-nqlinks">
          <button type="button" data-testid="nq-link-train" onClick={() => openNq("train")}>Formation</button>
          <button type="button" data-testid="nq-link-map" onClick={() => openNq("map")}>Carte du groupe</button>
          <button type="button" data-testid="nq-link-points" onClick={() => openNq("points")}>Points du jour</button>
        </p>
      </article>

      {inHuntStay(now) ? (
        <article className="og-hunt38__card" data-testid="sync-group">
          <h2>SYNCHRO DU GROUPE</h2>
          <p>{group?.answered || 0}/6 revenus/synchronisés</p>
          <p>{group?.received_points || 0} nouveaux points reçus</p>
          <button type="button" className="og-btn" data-testid="sync-evening" onClick={() => onOpen("nordquest-drop")}>Voir la collecte du soir</button>
        </article>
      ) : null}

      <article className="og-hunt38__card og-hunt38__meals" data-testid="supper-block">
        <h2>Repas / chalet</h2>
        <p data-testid="first-supper">{supperWhen} : {supper.who} — {supper.dish}</p>
        <p>{FREEZER}</p>
        <p>Chalet Desrochers</p>
        <div className="og-now__actions">
          <button type="button" className="og-btn" data-testid="tile-meals" onClick={() => onOpen("meals")}>Voir les repas</button>
          <button type="button" className="og-btn" data-testid="tile-chalet" onClick={() => onOpen("chalet")}>Voir le chalet</button>
        </div>
      </article>

      <article className="og-hunt38__card og-hunt38__gear">
        <h2>Matériel / véhicules</h2>
        <p>{CONVOYS[0].title} — Luc et Steve. {CONVOYS[1].title} — Éric et Marcel. Pierre et Dan : à confirmer.</p>
        <p>{TERRAIN_COUNT}</p>
        <div className="og-now__actions">
          <button type="button" className="og-btn" onClick={() => onOpen("gear")}>Voir le matériel</button>
          <button type="button" className="og-btn" onClick={() => onOpen("vehicles")}>Voir les véhicules</button>
          <button type="button" className="og-btn" onClick={() => onOpen("gear")}>Responsabilités</button>
        </div>
      </article>

      <article className="og-hunt38__card og-hunt38__depart" data-testid="depart-block">
        <h2>Départ</h2>
        <p className="og-now__facts" data-testid="hunt-facts">
          Chasse à l'orignal 2026 · Portneuf · Secteur 4 · {t.datesLine}
        </p>
        <p data-testid="hunt-depart">{t.departLine}</p>
        <p data-testid="hunt-rdv">{MEET_POINT}</p>
        <p>{t.arriveLine} · Sépaq 13 h 45</p>
        <p data-testid="today-group">Notre chasse — 2 au 9 octobre · {t.sixHunters} · Sépaq 13 h 45 · chasse 16 h 30</p>
        <p data-testid="plan-summary">Plan du jour · {planLine(teams)}</p>
        <button type="button" className="og-btn og-btn--primary" data-testid="open-organize" onClick={() => onOpen("organize")}>Voir / modifier le plan</button>
      </article>

      <article className="og-hunt38__card og-hunt38__hunters" data-testid="home-todo">
        <h2>Les chasseurs</h2>
        <div className="og-huntergrid">
          {hunters.map((hunter) => {
            const phone = phones.find((row) => row.member_id === hunter.id);
            const open = tasks.filter((task) => task.assignee_id === hunter.id && task.status !== "done").length;
            const nq = phoneReady(phone);
            return (
              <button key={hunter.id} type="button" className="og-tile og-tile--person" data-testid={`hunter-open-${hunter.id}`} onClick={() => onOpen(hunter.id)}>
                <strong data-testid={`member-${hunter.id}`}>{hunter.first_name}</strong>
                <span>{hunterLabel(hunter)}</span>
                <span>{nq ? "NQ prêt" : "NQ à installer"}</span>
                <span>{open === 0 && nq ? "Prêt" : "Pas prêt"}</span>
              </button>
            );
          })}
        </div>
      </article>
    </div>
  );
}
